import { useModuleNavigation } from "@/common/hooks/use-navigation";
import { DashboardSection } from "@/components/dashboard/dashboard-section";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { NoPermissionCard } from "@/components/no-permission-card/no-permission-card";
import { ChartLineIcon, SettingsIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CasaviSettings } from "./_components/casavi-settings";
import { ContactWhitelistMetric } from "./_components/contact-whitelist-metric";

export function CasaviDashboardView() {
  const { t } = useTranslation(["casavi", "common"]);
  const casaviConfig = useModuleNavigation("casavi");
  const pageTitle = `CAS ${t("common:Dashboard")}`;
  const pageSubtitle = t("casavi:DashboardDescription");

  if (!casaviConfig) {
    return <NoPermissionCard />;
  }

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Default} title={pageTitle} subTitle={pageSubtitle}>
      <DashboardSection title={t("common:Statistics")} icon={ChartLineIcon}>
        <ContactWhitelistMetric />
      </DashboardSection>

      <DashboardSection title={t("common:Configuration")} icon={SettingsIcon}>
        <CasaviSettings />
      </DashboardSection>
    </CenteredLayout>
  );
}
